import Vue from 'vue'

Vue.directive('enclosedtitle', {
    bind(el, binding, vnode) {
        el.style.display = 'inline-block';
        el.style.padding = '8px 15px';
        el.style.color = 'white';
        el.style.borderRadius = '6px';
        el.style.backgroundColor= 'rgba(0, 0, 0, 0.85)';
        // display: inline-block;
        // padding: 8px 15px;
        // margin: 15px 0;
        // border-radius: 6px;
    }
});